import script from "./UserArtistProfileDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UserArtistProfileDetail.vue?vue&type=script&setup=true&lang=js"

import "./UserArtistProfileDetail.vue?vue&type=style&index=0&id=225e1a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225e1a4c"]])

export default __exports__